export default class ExceptionInterpreter {
  static isHttpConflictException(e) {
    return this.isHttpResponseExceptionWithStatus(e, 409);
  }
  static isHttpUnprocessableEntityException(e) {
    return this.isHttpResponseExceptionWithStatus(e, 422);
  }
  static isUnauthorizedException(e) {
    return this.isHttpResponseExceptionWithStatus(e, 401) || this.isHttpResponseExceptionWithStatus(e, 403);
  }
  static isHttpResponseExceptionWithStatus(e, status) {
    if (this.isHttpResponseException(e) === false) {
      return false;
    }
    return e.response.status === status;
  }
  static isHttpResponseException(e) {
    return _.has(e, 'response.status');
  }
  static isNon2xxResponse(e) {
    if (!this.isHttpResponseException(e)) {
      return false;
    }
    const status = e.response.status;
    return status < 200 || status >= 300;
  }
  static isCancelledRequestException(e) {
    return e.toString() === 'Cancel';
  }
  static isValidationException(e) {
    return this.isHttpUnprocessableEntityException(e)
      && _.has(e, 'response.data.message')
      && _.has(e, 'response.data.errors');
  }
  static isBusinessLogicException(e) {
    return this.isHttpUnprocessableEntityException(e)
      && _.has(e, 'response.data.class')
      && _.has(e, 'response.data.alert')
      && _.has(e, 'response.data.additional');
  }
}
